import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from './styles';
import { getPromoCodeFromStore } from '../../../../../utility/promotionCode';
import history from '../../../../../history';
import { selectAppliedPromoCode, selectCurrentUser } from '../../../../../store/modules/users/selectors';

const PromoNote = () => {
  const classes = useStyles();
  const path = history.location.pathname;
  const savedPromoCode = getPromoCodeFromStore(false);
  const appliedPromoCode = useSelector(selectAppliedPromoCode);
  const availablePages = ['/', '/pages/pricing', '/dashboard/plans/pricing'];
  let { loading } = useSelector(selectCurrentUser);
  if (path.search('pages/pricing') !== -1 || path === '/') {
    loading = false;
  }

  if (!availablePages.includes(path)) {
    return null;
  }

  return (
    <>
      {savedPromoCode && !loading && !appliedPromoCode
      && (
        <div className={classes.root}>
          The promotion code "
          {savedPromoCode}
          " has been noted and any price adjustments will be made at the time of checkout.
        </div>
      )}
    </>
  );
};

export default PromoNote;
